import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Location } from "@angular/common";
import { AppError } from 'src/app/error-handler/app-error';
import { BadInputError } from 'src/app/error-handler/bad-input-error';
import { SiteService } from 'src/app/services/site.service';
import { catchError, throwError } from 'rxjs';
import { P } from '@angular/cdk/keycodes';




var ver = window['config'].version;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  public loginForm = new FormGroup<{ [key: string]: FormControl }>({
    username: new FormControl('', { validators: Validators.required, updateOn: 'blur' }),
    password: new FormControl('', [Validators.required]),
  });

  id = "tsparticles";
  dateNow: any = new Date();

  particlesOptions = {
    particles: {
      number: {
        value: 100,
      },
      size: {
        value: 5,
      },
      move: {
        enable: true,
        speed: 3,
      },
      line_linked: {
        enable: true,
        distance: 150,
        color: '#ffffff',
        opacity: 0.4,
        width: 1,
      },
      color: {
        value: '#ffffff',
      },
      shape: {
        type: 'circle',
      },
    },
    interactivity: {
      events: {
        onHover: {
          enable: true,
          mode: 'repulse',
        },
        onClick: {
          enable: true,
          mode: 'push',
        },
      },
      modes: {
        push: {
          particles_nb: 4,
        },
        repulse: {
          distance: 100,
          duration: 0.4,
        },
      },
    },
    retina_detect: true,
  
  };
 public capsOn: any;
 public hide: any;
 public myStyle: object = {};
 public myParams: object = {};
 public width: number = 100;
 public height: number = 100;
 public showForget = false
 public vr1 = ver
 public loginRoute: boolean = false;
 public forgotRoute: boolean = false;
 public resetRoute: boolean = false;
 public backToLogin: boolean = false;
 public showPassword: boolean = false;
 public showNewPassword: boolean = false;
 public showconfirmPassword: boolean = false;
 public isMatch: boolean=true;
 public resetCode: any;

  constructor(private route: ActivatedRoute, private router: Router, private authService: AuthService,
    private httpClient: HttpClient, private location: Location,private snotifyService: ToastrService,
    public siteService: SiteService) { }

  ngOnInit() {

    if (this.router.url === '/login') {
      this.loginRoute = true;
    }
    else if (this.router.url === '/forgot-password') {
      this.forgotRoute = true;
      this.loginForm.removeControl('password');
    }
    else if(this.router.url.includes('/reset-password') ) {
           
          this.resetRoute = true;
         
          this.loginForm.addControl('newPassword', new FormControl('', [Validators.required]));
          this.loginForm.addControl('confirmPassword', new FormControl('', [Validators.required]));
          this.loginForm.removeControl('password');
          this.loginForm.removeControl('username');
        

    
    }
    if (this.authService.isLoggedIn())
      this.router.navigate(['Dashboard']);


    this.myStyle = {
      'position': 'fixed',
      'width': '100%',
      'height': '100%',
      'z-index': 1,
      'top': 0,
      'left': 0,
      'right': 0,
      'bottom': 0,
    };

    this.myParams = {
      "particles": {
        "number": {
          "value": 50,
          "density": {
            "enable": true,
            "value_area": 500
          }
        },
        "color": {
          "value": "#caf6fc"
        },
        "shape": {
          "type": "circle",
          "stroke": {
            "width": 0,
            "color": "#000000"
          },
          "polygon": {
            "nb_sides": 5
          },
          "image": {
            "src": "img/github.svg",
            "width": 100,
            "height": 100
          }
        },
        "opacity": {
          "value": 1,
          "random": true,
          "anim": {
            "enable": true,
            "speed": 1,
            "opacity_min": 0,
            "sync": false
          }
        },
        "size": {
          "value": 3,
          "random": true,
          "anim": {
            "enable": false,
            "speed": 4,
            "size_min": 0.3,
            "sync": false
          }
        },
        "line_linked": {
          "enable": true,
          "distance": 200,
          "color": "#008fc7",
          "opacity": 0.1,
          "width": 1
        },
        "move": {
          "enable": true,
          "speed": .5,
          "direction": "none",
          "random": true,
          "straight": false,
          "out_mode": "out",
          "bounce": false,
          "attract": {
            "enable": false,
            "rotateX": 600,
            "rotateY": 600
          }
        }
      },
      "interactivity": {
        "detect_on": "canvas",
        "events": {
          "onhover": {
            "enable": true,
            "mode": "bubble"
          },
          "onclick": {
            "enable": true,
            "mode": "repulse"
          },
          "resize": true
        },
        "modes": {
          "grab": {
            "distance": 400,
            "line_linked": {
              "opacity": 1
            }
          },
          "bubble": {
            "distance": 250,
            "size": 0,
            "duration": 2,
            "opacity": 0,
            "speed": 3
          },
          "repulse": {
            "distance": 400,
            "duration": 0.4
          },
          "push": {
            "particles_nb": 4
          },
          "remove": {
            "particles_nb": 2
          }
        }
      },
      "retina_detect": true
    }
  }

  login(form) {
    if (form.invalid) { return; }

    if (this.loginRoute)
      this.authService.loggeIn(this.loginForm.controls.username.value, this.loginForm.controls.password.value)
//     .pipe((catchError((err)=>{
//       this.snotifyService.error(err.message)
//  return  throwError(err.message)})))
        .subscribe(
          res => {
          const deviceToken =localStorage.getItem("deviceToken")

            if(deviceToken){
              this.authService.saveDeviceToken(deviceToken)
            }
            this.siteService.reset();
            this.router.navigate(['Dashboard']);
          } );

    if (this.forgotRoute) {
      var pathArray = this.location.path().split('/');
      var newPathname = pathArray[1];
      this.authService.forgotPassword({
        Email: this.loginForm.controls.username.value,
        EmailTemplateId: 'ForgotPassword',
        Host: window.location.origin 
      }).subscribe((res: any) => {
        this.backToLogin = true;
        this.snotifyService.success("An email has been sent to your email");
      });
    }
    if (this.resetRoute) {
 
      if (this.loginForm.controls.newPassword.value == this.loginForm.controls.confirmPassword.value) {

        // let parameters = this.route.snapshot.paramMap.get('params');
        // parameters = parameters.split("user")[1].trim();
        // var user = parameters.split("key")[0].trim();
        // var Code = parameters.split("key")[1].trim();
        let user = this.route.snapshot.paramMap.get('userId');
        let Code =this.route.snapshot.paramMap.get('code');

        var data = {
          UserId: user,
          Password: this.loginForm.controls.newPassword.value,
          ConfirmPassword: this.loginForm.controls.confirmPassword.value,
          Code: Code,
          isResetPassword: true

        }
        this.httpClient.post(`/admin/reset-password`, data).subscribe((res: any) => {
         
          this.snotifyService.success("The password has been updated successfully");
          this.router.navigate(["login"]);
        });
      } else{this.isMatch = false;}
        
    }

  }
 
}
